
app.formsController = app.formsController || {};
app.formsController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        if ($('select').length > 0) {
            // Transform selects on no-touch devices
            $('select').customSelect();
        }
        
        if ($('[type="checkbox"]').length > 0) {
            this.transformCheck();
        }
        if ($('[type="radio"]').length > 0) {
            this.transformRadio();
        }
    },
    
    transformCheck : function () {
        $checkbox = $('[type="checkbox"]');
        $checkbox.each(function(){
            $check = $(this);
            $check.wrap('<span class="dummyCheck"></span>').after('<span class="dummySelected"></span>');
        });
    },
    
    transformRadio : function () {
        $radio = $('[type="radio"]');
        $radio.each(function(){
            $radio = $(this);
            $radio.wrap('<span class="dummyRadio"></span>').after('<span class="dummySelected"></span>');
        });
    },
        
};

$(document).ready(function(){
    app.formsController.defaultAction.init();
});
